const MockData = [
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-25',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-09',
    tumourStream: 'metastasis',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-27',
    tumourStream: 'urogenital',
    fractionDose: 1.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-03',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-28',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-12',
    tumourStream: 'urogenital',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-02',
    tumourStream: 'breast',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-15',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-13',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-10',
    tumourStream: 'skin',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'brain',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-25',
    tumourStream: 'metastasis',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-20',
    tumourStream: 'metastasis',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-15',
    tumourStream: 'metastasis',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-06',
    tumourStream: 'urogenital',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'brain',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'urogenital',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'brain',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-01',
    tumourStream: 'Unspecified',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-12',
    tumourStream: 'Unspecified',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-16',
    tumourStream: 'Unspecified',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-03-30',
    tumourStream: 'Unspecified',
    fractionDose: 2.4,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'Unspecified',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-19',
    tumourStream: 'Unspecified',
    fractionDose: 3.4,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-12',
    tumourStream: 'Unspecified',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-06',
    tumourStream: 'Unspecified',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-06-20',
    tumourStream: 'Unspecified',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'Unspecified',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-18',
    tumourStream: 'urogenital',
    fractionDose: 2.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-07',
    tumourStream: 'urogenital',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-14',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-03-23',
    tumourStream: 'breast',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-29',
    tumourStream: 'metastasis',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-14',
    tumourStream: 'breast',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-17',
    tumourStream: 'metastasis',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-12',
    tumourStream: 'skin',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-01',
    tumourStream: 'brain',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-05-15',
    tumourStream: 'brain',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-10',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-30',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-07',
    tumourStream: 'urogenital',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-04-14',
    tumourStream: 'metastasis',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-06-16',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-19',
    tumourStream: 'gi',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-07',
    tumourStream: 'skin',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-15',
    tumourStream: 'skin',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-13',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-15',
    tumourStream: 'gi',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-22',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-24',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-23',
    tumourStream: 'metastasis',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'breast',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-12',
    tumourStream: 'metastasis',
    fractionDose: 3.3,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-08',
    tumourStream: 'metastasis',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-21',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-13',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-11',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-08',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-21',
    tumourStream: 'urogenital',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-02',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-26',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-20',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-23',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-24',
    tumourStream: 'brain',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-14',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-04',
    tumourStream: 'breast',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-05',
    tumourStream: 'urogenital',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-15',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-22',
    tumourStream: 'gi',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-26',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-04',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-29',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-06',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-31',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-20',
    tumourStream: 'urogenital',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-01',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-07',
    tumourStream: 'metastasis',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-16',
    tumourStream: 'brain',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-23',
    tumourStream: 'urogenital',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-30',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-12',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-11',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-02',
    tumourStream: 'skin',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-05',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-07',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-27',
    tumourStream: 'brain',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-05',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-05',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-06',
    tumourStream: 'breast',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-08',
    tumourStream: 'skin',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },

  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-25',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-09',
    tumourStream: 'metastasis',
    fractionDose: 2.2,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-27',
    tumourStream: 'urogenital',
    fractionDose: 1.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-03',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-28',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-12',
    tumourStream: 'urogenital',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-02',
    tumourStream: 'breast',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-15',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-13',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-10',
    tumourStream: 'skin',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'brain',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-25',
    tumourStream: 'metastasis',
    fractionDose: 3.0,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-20',
    tumourStream: 'metastasis',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-15',
    tumourStream: 'metastasis',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-06',
    tumourStream: 'urogenital',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'brain',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'urogenital',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'brain',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-01',
    tumourStream: 'metastasis',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-12',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-16',
    tumourStream: 'metastasis',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-03-30',
    tumourStream: 'gi',
    fractionDose: 2.4,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-19',
    tumourStream: 'brain',
    fractionDose: 3.4,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-12',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-06',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-06-20',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-18',
    tumourStream: 'urogenital',
    fractionDose: 2.0,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-07',
    tumourStream: 'urogenital',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-14',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-03-23',
    tumourStream: 'breast',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-29',
    tumourStream: 'metastasis',
    fractionDose: 1.7,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-14',
    tumourStream: 'breast',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-17',
    tumourStream: 'metastasis',
    fractionDose: 2.8,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-12',
    tumourStream: 'skin',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-01',
    tumourStream: 'brain',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-05-15',
    tumourStream: 'brain',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-10',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-30',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-07',
    tumourStream: 'urogenital',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-04-14',
    tumourStream: 'metastasis',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-06-16',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-19',
    tumourStream: 'gi',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-07',
    tumourStream: 'skin',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-15',
    tumourStream: 'skin',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-13',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-15',
    tumourStream: 'gi',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-22',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-24',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-23',
    tumourStream: 'metastasis',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'breast',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-12',
    tumourStream: 'metastasis',
    fractionDose: 3.3,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-08',
    tumourStream: 'metastasis',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-21',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-13',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-11',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-08',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-21',
    tumourStream: 'urogenital',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-02',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-26',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-20',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-23',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-24',
    tumourStream: 'brain',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-14',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-04',
    tumourStream: 'breast',
    fractionDose: 2.9,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-05',
    tumourStream: 'urogenital',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-15',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-22',
    tumourStream: 'gi',
    fractionDose: 3.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-26',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-04',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-29',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-06',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-31',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-20',
    tumourStream: 'urogenital',
    fractionDose: 1.7,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-01',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-07',
    tumourStream: 'metastasis',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-16',
    tumourStream: 'brain',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-23',
    tumourStream: 'urogenital',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-30',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-12',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-11',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-02',
    tumourStream: 'skin',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-05',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-07',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-27',
    tumourStream: 'brain',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-05',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-05',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-06',
    tumourStream: 'breast',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-08',
    tumourStream: 'skin',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },

  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-25',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-09',
    tumourStream: 'metastasis',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-27',
    tumourStream: 'urogenital',
    fractionDose: 1.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-03',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-28',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-12',
    tumourStream: 'urogenital',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-02',
    tumourStream: 'breast',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-15',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-13',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-10',
    tumourStream: 'skin',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'brain',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-25',
    tumourStream: 'metastasis',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-20',
    tumourStream: 'metastasis',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-15',
    tumourStream: 'metastasis',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-06',
    tumourStream: 'urogenital',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'brain',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'urogenital',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'brain',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-01',
    tumourStream: 'metastasis',
    fractionDose: 1.4,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-12',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-16',
    tumourStream: 'metastasis',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-03-30',
    tumourStream: 'gi',
    fractionDose: 2.4,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-19',
    tumourStream: 'brain',
    fractionDose: 3.4,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-12',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-06',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-06-20',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-18',
    tumourStream: 'urogenital',
    fractionDose: 2.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-07',
    tumourStream: 'urogenital',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-14',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-03-23',
    tumourStream: 'breast',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-29',
    tumourStream: 'metastasis',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-14',
    tumourStream: 'breast',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-09-17',
    tumourStream: 'metastasis',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-12',
    tumourStream: 'skin',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-01',
    tumourStream: 'brain',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-05-15',
    tumourStream: 'brain',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-10',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-30',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-07',
    tumourStream: 'urogenital',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-04-14',
    tumourStream: 'metastasis',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-16',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-19',
    tumourStream: 'gi',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-07',
    tumourStream: 'skin',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-15',
    tumourStream: 'skin',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-13',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-15',
    tumourStream: 'gi',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-22',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-24',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-23',
    tumourStream: 'metastasis',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'breast',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-12',
    tumourStream: 'metastasis',
    fractionDose: 3.3,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-08',
    tumourStream: 'metastasis',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-21',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-13',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-11',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-08',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-21',
    tumourStream: 'urogenital',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-02',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-26',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-20',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-23',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-24',
    tumourStream: 'brain',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-14',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-09-04',
    tumourStream: 'breast',
    fractionDose: 2.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-05',
    tumourStream: 'urogenital',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-15',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-22',
    tumourStream: 'gi',
    fractionDose: 3.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-26',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-04',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-29',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-06',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-31',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-20',
    tumourStream: 'urogenital',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-01',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-07',
    tumourStream: 'metastasis',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-16',
    tumourStream: 'brain',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-23',
    tumourStream: 'urogenital',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-30',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-12',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-11',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-02',
    tumourStream: 'skin',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-05',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-07',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-27',
    tumourStream: 'brain',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-05',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-05',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-06',
    tumourStream: 'breast',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-08',
    tumourStream: 'skin',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },

  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-25',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-09',
    tumourStream: 'metastasis',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-27',
    tumourStream: 'urogenital',
    fractionDose: 1.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-03',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-28',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-12',
    tumourStream: 'urogenital',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-02',
    tumourStream: 'breast',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-15',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-13',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-10',
    tumourStream: 'skin',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'brain',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-25',
    tumourStream: 'metastasis',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-20',
    tumourStream: 'metastasis',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-01-15',
    tumourStream: 'metastasis',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-06',
    tumourStream: 'urogenital',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-04',
    tumourStream: 'gi',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'brain',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-04',
    tumourStream: 'urogenital',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'brain',
    fractionDose: 1.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-09-01',
    tumourStream: 'metastasis',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-12',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-16',
    tumourStream: 'metastasis',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-03-30',
    tumourStream: 'gi',
    fractionDose: 2.4,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-19',
    tumourStream: 'brain',
    fractionDose: 3.4,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-12',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-06',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-06-20',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-18',
    tumourStream: 'urogenital',
    fractionDose: 2.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-04-07',
    tumourStream: 'urogenital',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-14',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-03-23',
    tumourStream: 'breast',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-29',
    tumourStream: 'metastasis',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-02-14',
    tumourStream: 'breast',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-17',
    tumourStream: 'metastasis',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-12',
    tumourStream: 'skin',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-01',
    tumourStream: 'brain',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-05-15',
    tumourStream: 'brain',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-10',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-06-30',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-07',
    tumourStream: 'urogenital',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-04-14',
    tumourStream: 'metastasis',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-06-16',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-19',
    tumourStream: 'gi',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-07',
    tumourStream: 'skin',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-15',
    tumourStream: 'skin',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-13',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-02-15',
    tumourStream: 'gi',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-22',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-01-24',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-23',
    tumourStream: 'metastasis',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-18',
    tumourStream: 'breast',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-12',
    tumourStream: 'metastasis',
    fractionDose: 3.3,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-08',
    tumourStream: 'metastasis',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-21',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-13',
    tumourStream: 'brain',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-11',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-08',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-01-21',
    tumourStream: 'urogenital',
    fractionDose: 2.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-08-02',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-04-26',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-07-20',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-23',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-24',
    tumourStream: 'brain',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-14',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-04',
    tumourStream: 'breast',
    fractionDose: 2.9,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-05',
    tumourStream: 'urogenital',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-15',
    tumourStream: 'brain',
    fractionDose: 1.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-22',
    tumourStream: 'gi',
    fractionDose: 3.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-09-25',
    tumourStream: 'gi',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-05-26',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-04',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-29',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-06',
    tumourStream: 'breast',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-31',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-07-20',
    tumourStream: 'urogenital',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-01',
    tumourStream: 'gi',
    fractionDose: 2.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-08-07',
    tumourStream: 'metastasis',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-08-16',
    tumourStream: 'brain',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-23',
    tumourStream: 'urogenital',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-04-30',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-07-12',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-02-05',
    tumourStream: 'gi',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-06-11',
    tumourStream: 'urogenital',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-03-02',
    tumourStream: 'skin',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-08-05',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-22',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-07',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-05-27',
    tumourStream: 'brain',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-07-05',
    tumourStream: 'metastasis',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-03-10',
    tumourStream: 'breast',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-02-05',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-01-06',
    tumourStream: 'breast',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-09-14',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-05-08',
    tumourStream: 'skin',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-30',
    tumourStream: 'breast',
    fractionDose: 1.68,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-08',
    tumourStream: 'Unspecified',
    fractionDose: 2.27,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-22',
    tumourStream: 'skin',
    fractionDose: 1.66,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-23',
    tumourStream: 'urogenital',
    fractionDose: 1.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-07',
    tumourStream: 'breast',
    fractionDose: 1.79,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-17',
    tumourStream: 'Unspecified',
    fractionDose: 3.39,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-02',
    tumourStream: 'gi',
    fractionDose: 2.15,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-06',
    tumourStream: 'urogenital',
    fractionDose: 1.81,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-18',
    tumourStream: 'breast',
    fractionDose: 2.93,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-24',
    tumourStream: 'gi',
    fractionDose: 3.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-23',
    tumourStream: 'urogenital',
    fractionDose: 1.25,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-15',
    tumourStream: 'metastasis',
    fractionDose: 3.37,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-19',
    tumourStream: 'skin',
    fractionDose: 1.73,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-12',
    tumourStream: 'skin',
    fractionDose: 2.78,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-14',
    tumourStream: 'skin',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-26',
    tumourStream: 'breast',
    fractionDose: 1.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-13',
    tumourStream: 'metastasis',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-18',
    tumourStream: 'metastasis',
    fractionDose: 2.59,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-20',
    tumourStream: 'gi',
    fractionDose: 2.38,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-26',
    tumourStream: 'brain',
    fractionDose: 2.08,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-03',
    tumourStream: 'urogenital',
    fractionDose: 1.25,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-16',
    tumourStream: 'urogenital',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-31',
    tumourStream: 'Unspecified',
    fractionDose: 1.67,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-13',
    tumourStream: 'urogenital',
    fractionDose: 1.88,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-24',
    tumourStream: 'urogenital',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-29',
    tumourStream: 'skin',
    fractionDose: 3.09,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-12',
    tumourStream: 'breast',
    fractionDose: 1.59,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-21',
    tumourStream: 'urogenital',
    fractionDose: 1.82,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-23',
    tumourStream: 'breast',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-24',
    tumourStream: 'gi',
    fractionDose: 2.36,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-27',
    tumourStream: 'gi',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-25',
    tumourStream: 'urogenital',
    fractionDose: 2.04,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-15',
    tumourStream: 'gi',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-30',
    tumourStream: 'Unspecified',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-15',
    tumourStream: 'gi',
    fractionDose: 3.25,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-02',
    tumourStream: 'brain',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-04',
    tumourStream: 'Unspecified',
    fractionDose: 3.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-20',
    tumourStream: 'urogenital',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-02',
    tumourStream: 'Unspecified',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-15',
    tumourStream: 'Unspecified',
    fractionDose: 1.89,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-10',
    tumourStream: 'metastasis',
    fractionDose: 1.71,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-05',
    tumourStream: 'breast',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-30',
    tumourStream: 'skin',
    fractionDose: 3.36,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-14',
    tumourStream: 'gi',
    fractionDose: 2.56,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-15',
    tumourStream: 'skin',
    fractionDose: 1.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-26',
    tumourStream: 'brain',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-16',
    tumourStream: 'skin',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-25',
    tumourStream: 'skin',
    fractionDose: 2.71,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-22',
    tumourStream: 'skin',
    fractionDose: 3.27,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.85,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-03',
    tumourStream: 'metastasis',
    fractionDose: 1.43,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-18',
    tumourStream: 'urogenital',
    fractionDose: 1.88,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-23',
    tumourStream: 'skin',
    fractionDose: 1.63,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-08',
    tumourStream: 'brain',
    fractionDose: 1.78,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-05',
    tumourStream: 'gi',
    fractionDose: 1.78,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.77,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-03',
    tumourStream: 'gi',
    fractionDose: 2.69,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-29',
    tumourStream: 'breast',
    fractionDose: 2.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-09',
    tumourStream: 'gi',
    fractionDose: 2.52,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-03',
    tumourStream: 'brain',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-14',
    tumourStream: 'Unspecified',
    fractionDose: 2.27,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-08',
    tumourStream: 'skin',
    fractionDose: 2.03,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-23',
    tumourStream: 'Unspecified',
    fractionDose: 1.34,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-14',
    tumourStream: 'metastasis',
    fractionDose: 2.21,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-28',
    tumourStream: 'skin',
    fractionDose: 1.72,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-20',
    tumourStream: 'metastasis',
    fractionDose: 2.39,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-20',
    tumourStream: 'breast',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-21',
    tumourStream: 'breast',
    fractionDose: 2.91,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-24',
    tumourStream: 'metastasis',
    fractionDose: 2.27,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-22',
    tumourStream: 'Unspecified',
    fractionDose: 3.05,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-30',
    tumourStream: 'gi',
    fractionDose: 3.29,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-28',
    tumourStream: 'Unspecified',
    fractionDose: 2.07,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-03',
    tumourStream: 'skin',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-08',
    tumourStream: 'urogenital',
    fractionDose: 1.48,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-19',
    tumourStream: 'metastasis',
    fractionDose: 1.39,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-01',
    tumourStream: 'breast',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-21',
    tumourStream: 'breast',
    fractionDose: 1.48,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-13',
    tumourStream: 'metastasis',
    fractionDose: 3.03,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-04',
    tumourStream: 'urogenital',
    fractionDose: 1.21,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-19',
    tumourStream: 'Unspecified',
    fractionDose: 2.53,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-26',
    tumourStream: 'gi',
    fractionDose: 2.48,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-07',
    tumourStream: 'Unspecified',
    fractionDose: 3.1,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-23',
    tumourStream: 'breast',
    fractionDose: 2.01,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-26',
    tumourStream: 'metastasis',
    fractionDose: 2.55,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-19',
    tumourStream: 'urogenital',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-04',
    tumourStream: 'breast',
    fractionDose: 1.48,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-14',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-03',
    tumourStream: 'brain',
    fractionDose: 3.11,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-13',
    tumourStream: 'Unspecified',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-06',
    tumourStream: 'gi',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-04',
    tumourStream: 'gi',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-06',
    tumourStream: 'metastasis',
    fractionDose: 2.46,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-17',
    tumourStream: 'brain',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-21',
    tumourStream: 'breast',
    fractionDose: 2.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-15',
    tumourStream: 'brain',
    fractionDose: 1.65,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-12',
    tumourStream: 'gi',
    fractionDose: 3.05,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-05',
    tumourStream: 'gi',
    fractionDose: 1.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-01',
    tumourStream: 'breast',
    fractionDose: 2.95,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-07',
    tumourStream: 'metastasis',
    fractionDose: 3.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-07',
    tumourStream: 'skin',
    fractionDose: 2.25,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-04',
    tumourStream: 'Unspecified',
    fractionDose: 1.35,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-29',
    tumourStream: 'urogenital',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-19',
    tumourStream: 'urogenital',
    fractionDose: 3.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-02',
    tumourStream: 'metastasis',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-30',
    tumourStream: 'gi',
    fractionDose: 2.14,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-25',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-02',
    tumourStream: 'metastasis',
    fractionDose: 2.93,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-22',
    tumourStream: 'brain',
    fractionDose: 2.52,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-25',
    tumourStream: 'Unspecified',
    fractionDose: 2.47,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-04',
    tumourStream: 'Unspecified',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-18',
    tumourStream: 'breast',
    fractionDose: 2.08,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-05',
    tumourStream: 'gi',
    fractionDose: 2.54,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-01',
    tumourStream: 'gi',
    fractionDose: 1.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-05',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-15',
    tumourStream: 'skin',
    fractionDose: 2.36,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-24',
    tumourStream: 'urogenital',
    fractionDose: 2.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-27',
    tumourStream: 'Unspecified',
    fractionDose: 3.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-07',
    tumourStream: 'brain',
    fractionDose: 2.41,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-29',
    tumourStream: 'Unspecified',
    fractionDose: 2.44,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-14',
    tumourStream: 'Unspecified',
    fractionDose: 1.81,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-26',
    tumourStream: 'brain',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-19',
    tumourStream: 'metastasis',
    fractionDose: 1.48,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-11',
    tumourStream: 'urogenital',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-27',
    tumourStream: 'Unspecified',
    fractionDose: 3.31,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-28',
    tumourStream: 'breast',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-07',
    tumourStream: 'gi',
    fractionDose: 3.09,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-01',
    tumourStream: 'metastasis',
    fractionDose: 2.86,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-07',
    tumourStream: 'skin',
    fractionDose: 2.69,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-01',
    tumourStream: 'urogenital',
    fractionDose: 3.23,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-16',
    tumourStream: 'metastasis',
    fractionDose: 2.44,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-25',
    tumourStream: 'brain',
    fractionDose: 2.09,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-13',
    tumourStream: 'metastasis',
    fractionDose: 1.25,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-02',
    tumourStream: 'gi',
    fractionDose: 1.42,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-18',
    tumourStream: 'gi',
    fractionDose: 2.05,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-15',
    tumourStream: 'breast',
    fractionDose: 1.64,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-03',
    tumourStream: 'gi',
    fractionDose: 1.81,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-21',
    tumourStream: 'urogenital',
    fractionDose: 1.78,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-08',
    tumourStream: 'brain',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-16',
    tumourStream: 'metastasis',
    fractionDose: 1.36,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-06',
    tumourStream: 'Unspecified',
    fractionDose: 2.62,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-13',
    tumourStream: 'gi',
    fractionDose: 2.44,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-23',
    tumourStream: 'metastasis',
    fractionDose: 2.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-23',
    tumourStream: 'skin',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-02',
    tumourStream: 'Unspecified',
    fractionDose: 2.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-06',
    tumourStream: 'gi',
    fractionDose: 2.53,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-30',
    tumourStream: 'urogenital',
    fractionDose: 2.43,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-23',
    tumourStream: 'metastasis',
    fractionDose: 1.38,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-18',
    tumourStream: 'urogenital',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-06',
    tumourStream: 'breast',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-23',
    tumourStream: 'gi',
    fractionDose: 3.12,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-26',
    tumourStream: 'urogenital',
    fractionDose: 2.93,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-07',
    tumourStream: 'urogenital',
    fractionDose: 1.91,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-01',
    tumourStream: 'Unspecified',
    fractionDose: 1.39,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-01',
    tumourStream: 'brain',
    fractionDose: 1.41,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-04',
    tumourStream: 'brain',
    fractionDose: 1.66,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-13',
    tumourStream: 'skin',
    fractionDose: 1.55,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-31',
    tumourStream: 'brain',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-19',
    tumourStream: 'gi',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-07',
    tumourStream: 'brain',
    fractionDose: 1.61,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-08',
    tumourStream: 'breast',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-03',
    tumourStream: 'Unspecified',
    fractionDose: 2.46,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-27',
    tumourStream: 'breast',
    fractionDose: 2.91,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-13',
    tumourStream: 'gi',
    fractionDose: 2.97,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-13',
    tumourStream: 'metastasis',
    fractionDose: 1.33,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-26',
    tumourStream: 'metastasis',
    fractionDose: 1.98,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-18',
    tumourStream: 'gi',
    fractionDose: 3.2,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-16',
    tumourStream: 'brain',
    fractionDose: 1.75,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-18',
    tumourStream: 'brain',
    fractionDose: 1.25,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-19',
    tumourStream: 'metastasis',
    fractionDose: 1.83,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-29',
    tumourStream: 'skin',
    fractionDose: 3.36,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-01',
    tumourStream: 'urogenital',
    fractionDose: 3.24,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-18',
    tumourStream: 'breast',
    fractionDose: 1.87,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-01',
    tumourStream: 'breast',
    fractionDose: 2.33,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-13',
    tumourStream: 'breast',
    fractionDose: 2.68,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-08',
    tumourStream: 'urogenital',
    fractionDose: 2.13,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-19',
    tumourStream: 'gi',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-15',
    tumourStream: 'metastasis',
    fractionDose: 3.29,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-04',
    tumourStream: 'urogenital',
    fractionDose: 2.95,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-12',
    tumourStream: 'skin',
    fractionDose: 2.02,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-05',
    tumourStream: 'gi',
    fractionDose: 3.09,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-20',
    tumourStream: 'Unspecified',
    fractionDose: 2.98,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-27',
    tumourStream: 'gi',
    fractionDose: 2.41,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-17',
    tumourStream: 'metastasis',
    fractionDose: 1.45,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-08',
    tumourStream: 'Unspecified',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-22',
    tumourStream: 'gi',
    fractionDose: 1.65,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-09',
    tumourStream: 'breast',
    fractionDose: 1.79,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-09',
    tumourStream: 'Unspecified',
    fractionDose: 1.56,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-28',
    tumourStream: 'breast',
    fractionDose: 2.55,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-25',
    tumourStream: 'gi',
    fractionDose: 2.28,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-21',
    tumourStream: 'metastasis',
    fractionDose: 2.03,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-16',
    tumourStream: 'brain',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-02',
    tumourStream: 'gi',
    fractionDose: 2.69,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-30',
    tumourStream: 'breast',
    fractionDose: 2.69,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-14',
    tumourStream: 'skin',
    fractionDose: 1.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-14',
    tumourStream: 'skin',
    fractionDose: 3.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-19',
    tumourStream: 'metastasis',
    fractionDose: 1.83,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-20',
    tumourStream: 'Unspecified',
    fractionDose: 2.38,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-06',
    tumourStream: 'urogenital',
    fractionDose: 3.21,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-10',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-03',
    tumourStream: 'skin',
    fractionDose: 2.43,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-11',
    tumourStream: 'gi',
    fractionDose: 1.65,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-08',
    tumourStream: 'brain',
    fractionDose: 2.93,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'Unspecified',
    fractionDose: 2.33,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-18',
    tumourStream: 'skin',
    fractionDose: 1.66,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-04',
    tumourStream: 'urogenital',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-05',
    tumourStream: 'gi',
    fractionDose: 1.57,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-14',
    tumourStream: 'gi',
    fractionDose: 1.55,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-13',
    tumourStream: 'urogenital',
    fractionDose: 1.44,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-16',
    tumourStream: 'urogenital',
    fractionDose: 1.24,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-28',
    tumourStream: 'gi',
    fractionDose: 1.32,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'urogenital',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-15',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-15',
    tumourStream: 'metastasis',
    fractionDose: 3.04,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-18',
    tumourStream: 'breast',
    fractionDose: 1.86,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-19',
    tumourStream: 'breast',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-31',
    tumourStream: 'urogenital',
    fractionDose: 2.5,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-31',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-03',
    tumourStream: 'urogenital',
    fractionDose: 2.08,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-20',
    tumourStream: 'metastasis',
    fractionDose: 1.81,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-01',
    tumourStream: 'skin',
    fractionDose: 1.56,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-10',
    tumourStream: 'Unspecified',
    fractionDose: 2.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-21',
    tumourStream: 'metastasis',
    fractionDose: 1.77,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-11',
    tumourStream: 'gi',
    fractionDose: 1.93,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-07',
    tumourStream: 'Unspecified',
    fractionDose: 1.31,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-13',
    tumourStream: 'metastasis',
    fractionDose: 1.96,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-07',
    tumourStream: 'skin',
    fractionDose: 1.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-02',
    tumourStream: 'metastasis',
    fractionDose: 3.15,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-18',
    tumourStream: 'skin',
    fractionDose: 1.92,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-25',
    tumourStream: 'gi',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-03',
    tumourStream: 'metastasis',
    fractionDose: 3.36,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-17',
    tumourStream: 'brain',
    fractionDose: 1.57,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-15',
    tumourStream: 'skin',
    fractionDose: 2.68,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-17',
    tumourStream: 'gi',
    fractionDose: 1.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-26',
    tumourStream: 'urogenital',
    fractionDose: 1.46,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-11',
    tumourStream: 'breast',
    fractionDose: 2.01,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-29',
    tumourStream: 'urogenital',
    fractionDose: 3.38,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-23',
    tumourStream: 'brain',
    fractionDose: 3.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-04',
    tumourStream: 'brain',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-19',
    tumourStream: 'gi',
    fractionDose: 2.27,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-22',
    tumourStream: 'Unspecified',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-01',
    tumourStream: 'gi',
    fractionDose: 1.55,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-26',
    tumourStream: 'urogenital',
    fractionDose: 2.92,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-09',
    tumourStream: 'skin',
    fractionDose: 1.75,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-27',
    tumourStream: 'brain',
    fractionDose: 2.59,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-13',
    tumourStream: 'metastasis',
    fractionDose: 1.72,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-22',
    tumourStream: 'urogenital',
    fractionDose: 3.06,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-06',
    tumourStream: 'gi',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-06',
    tumourStream: 'breast',
    fractionDose: 2.57,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-05',
    tumourStream: 'skin',
    fractionDose: 2.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-27',
    tumourStream: 'metastasis',
    fractionDose: 3.35,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-16',
    tumourStream: 'brain',
    fractionDose: 2.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-01',
    tumourStream: 'breast',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-15',
    tumourStream: 'Unspecified',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-22',
    tumourStream: 'urogenital',
    fractionDose: 1.7,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-28',
    tumourStream: 'gi',
    fractionDose: 1.69,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-11',
    tumourStream: 'urogenital',
    fractionDose: 1.82,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-25',
    tumourStream: 'Unspecified',
    fractionDose: 1.39,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-29',
    tumourStream: 'skin',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-20',
    tumourStream: 'metastasis',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-09',
    tumourStream: 'metastasis',
    fractionDose: 1.34,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-08',
    tumourStream: 'brain',
    fractionDose: 1.6,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-16',
    tumourStream: 'skin',
    fractionDose: 2.08,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-23',
    tumourStream: 'Unspecified',
    fractionDose: 3.18,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-18',
    tumourStream: 'gi',
    fractionDose: 2.08,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-30',
    tumourStream: 'Unspecified',
    fractionDose: 2.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-21',
    tumourStream: 'brain',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-19',
    tumourStream: 'urogenital',
    fractionDose: 1.88,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-23',
    tumourStream: 'brain',
    fractionDose: 2.59,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-16',
    tumourStream: 'skin',
    fractionDose: 2.49,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-07',
    tumourStream: 'Unspecified',
    fractionDose: 3.29,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-22',
    tumourStream: 'metastasis',
    fractionDose: 3.31,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-04',
    tumourStream: 'gi',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-28',
    tumourStream: 'Unspecified',
    fractionDose: 2.47,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-18',
    tumourStream: 'Unspecified',
    fractionDose: 1.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-17',
    tumourStream: 'urogenital',
    fractionDose: 1.62,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-02',
    tumourStream: 'skin',
    fractionDose: 1.56,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-03',
    tumourStream: 'gi',
    fractionDose: 2.34,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-15',
    tumourStream: 'brain',
    fractionDose: 2.75,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-09',
    tumourStream: 'urogenital',
    fractionDose: 1.27,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-27',
    tumourStream: 'Unspecified',
    fractionDose: 3.09,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-31',
    tumourStream: 'Unspecified',
    fractionDose: 1.62,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-28',
    tumourStream: 'metastasis',
    fractionDose: 2.99,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-20',
    tumourStream: 'metastasis',
    fractionDose: 1.72,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-20',
    tumourStream: 'brain',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-02',
    tumourStream: 'gi',
    fractionDose: 1.42,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-15',
    tumourStream: 'breast',
    fractionDose: 2.85,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-09',
    tumourStream: 'breast',
    fractionDose: 2.57,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-26',
    tumourStream: 'Unspecified',
    fractionDose: 1.92,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-10',
    tumourStream: 'metastasis',
    fractionDose: 3.02,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-01',
    tumourStream: 'brain',
    fractionDose: 1.53,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-16',
    tumourStream: 'skin',
    fractionDose: 3.13,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-04',
    tumourStream: 'skin',
    fractionDose: 2.87,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-07',
    tumourStream: 'Unspecified',
    fractionDose: 2.45,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-28',
    tumourStream: 'urogenital',
    fractionDose: 2.64,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-08',
    tumourStream: 'brain',
    fractionDose: 1.85,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-03',
    tumourStream: 'skin',
    fractionDose: 2.44,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-09',
    tumourStream: 'urogenital',
    fractionDose: 2.53,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-22',
    tumourStream: 'skin',
    fractionDose: 1.36,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-05',
    tumourStream: 'urogenital',
    fractionDose: 2.64,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-09',
    tumourStream: 'brain',
    fractionDose: 3.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-24',
    tumourStream: 'Unspecified',
    fractionDose: 1.43,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-09',
    tumourStream: 'Unspecified',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-09',
    tumourStream: 'brain',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-10',
    tumourStream: 'gi',
    fractionDose: 1.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-05',
    tumourStream: 'gi',
    fractionDose: 3.11,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-07',
    tumourStream: 'urogenital',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-16',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-07',
    tumourStream: 'gi',
    fractionDose: 2.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-30',
    tumourStream: 'brain',
    fractionDose: 2.04,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-22',
    tumourStream: 'brain',
    fractionDose: 1.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-02',
    tumourStream: 'brain',
    fractionDose: 2.48,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-09',
    tumourStream: 'metastasis',
    fractionDose: 2.09,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-27',
    tumourStream: 'urogenital',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-13',
    tumourStream: 'breast',
    fractionDose: 3.11,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-20',
    tumourStream: 'metastasis',
    fractionDose: 1.77,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-15',
    tumourStream: 'gi',
    fractionDose: 3.16,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-22',
    tumourStream: 'skin',
    fractionDose: 2.34,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-17',
    tumourStream: 'brain',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-14',
    tumourStream: 'brain',
    fractionDose: 2.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-11',
    tumourStream: 'gi',
    fractionDose: 2.79,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-02',
    tumourStream: 'metastasis',
    fractionDose: 1.28,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-27',
    tumourStream: 'brain',
    fractionDose: 2.76,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-14',
    tumourStream: 'breast',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-26',
    tumourStream: 'gi',
    fractionDose: 1.34,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-28',
    tumourStream: 'brain',
    fractionDose: 3.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-21',
    tumourStream: 'brain',
    fractionDose: 2.27,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-01',
    tumourStream: 'skin',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-11',
    tumourStream: 'urogenital',
    fractionDose: 2.21,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-20',
    tumourStream: 'gi',
    fractionDose: 2.94,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-28',
    tumourStream: 'Unspecified',
    fractionDose: 3.27,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-02',
    tumourStream: 'breast',
    fractionDose: 3.01,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-10',
    tumourStream: 'skin',
    fractionDose: 1.32,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-30',
    tumourStream: 'skin',
    fractionDose: 3.33,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-04',
    tumourStream: 'Unspecified',
    fractionDose: 1.41,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-14',
    tumourStream: 'gi',
    fractionDose: 2.57,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-06',
    tumourStream: 'urogenital',
    fractionDose: 1.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-01',
    tumourStream: 'Unspecified',
    fractionDose: 1.53,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-01',
    tumourStream: 'gi',
    fractionDose: 2.65,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-19',
    tumourStream: 'metastasis',
    fractionDose: 2.82,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-30',
    tumourStream: 'breast',
    fractionDose: 2.46,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-04',
    tumourStream: 'Unspecified',
    fractionDose: 2.78,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-20',
    tumourStream: 'breast',
    fractionDose: 1.77,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-24',
    tumourStream: 'breast',
    fractionDose: 2.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-07',
    tumourStream: 'gi',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-25',
    tumourStream: 'breast',
    fractionDose: 1.99,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-18',
    tumourStream: 'Unspecified',
    fractionDose: 1.81,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-04',
    tumourStream: 'brain',
    fractionDose: 1.86,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-22',
    tumourStream: 'brain',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-04',
    tumourStream: 'breast',
    fractionDose: 1.21,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-23',
    tumourStream: 'breast',
    fractionDose: 1.33,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-08',
    tumourStream: 'brain',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-30',
    tumourStream: 'metastasis',
    fractionDose: 3.03,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-15',
    tumourStream: 'skin',
    fractionDose: 1.84,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-11',
    tumourStream: 'skin',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-16',
    tumourStream: 'urogenital',
    fractionDose: 1.64,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-07',
    tumourStream: 'urogenital',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-25',
    tumourStream: 'brain',
    fractionDose: 2.56,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-18',
    tumourStream: 'urogenital',
    fractionDose: 3.19,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-16',
    tumourStream: 'Unspecified',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-25',
    tumourStream: 'urogenital',
    fractionDose: 3.36,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-27',
    tumourStream: 'gi',
    fractionDose: 1.27,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-21',
    tumourStream: 'brain',
    fractionDose: 1.66,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-03',
    tumourStream: 'skin',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-07',
    tumourStream: 'breast',
    fractionDose: 2.45,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-05',
    tumourStream: 'Unspecified',
    fractionDose: 3.35,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.88,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-07',
    tumourStream: 'urogenital',
    fractionDose: 2.47,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-22',
    tumourStream: 'breast',
    fractionDose: 3.18,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-13',
    tumourStream: 'skin',
    fractionDose: 1.95,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-11',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-09',
    tumourStream: 'gi',
    fractionDose: 3.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-02',
    tumourStream: 'Unspecified',
    fractionDose: 3.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-26',
    tumourStream: 'urogenital',
    fractionDose: 1.83,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-22',
    tumourStream: 'metastasis',
    fractionDose: 2.08,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-03',
    tumourStream: 'breast',
    fractionDose: 2.68,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-25',
    tumourStream: 'breast',
    fractionDose: 1.89,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-24',
    tumourStream: 'Unspecified',
    fractionDose: 1.36,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-29',
    tumourStream: 'skin',
    fractionDose: 1.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-20',
    tumourStream: 'gi',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-03',
    tumourStream: 'gi',
    fractionDose: 1.83,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-12',
    tumourStream: 'Unspecified',
    fractionDose: 2.73,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-16',
    tumourStream: 'urogenital',
    fractionDose: 3.24,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-29',
    tumourStream: 'Unspecified',
    fractionDose: 2.22,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-07',
    tumourStream: 'Unspecified',
    fractionDose: 3.06,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-23',
    tumourStream: 'urogenital',
    fractionDose: 1.31,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-29',
    tumourStream: 'skin',
    fractionDose: 2.15,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-19',
    tumourStream: 'breast',
    fractionDose: 2.76,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-04',
    tumourStream: 'Unspecified',
    fractionDose: 2.89,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-18',
    tumourStream: 'gi',
    fractionDose: 1.42,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-25',
    tumourStream: 'skin',
    fractionDose: 2.85,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-05',
    tumourStream: 'urogenital',
    fractionDose: 1.49,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-05',
    tumourStream: 'gi',
    fractionDose: 2.89,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-23',
    tumourStream: 'brain',
    fractionDose: 1.27,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-12',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-04',
    tumourStream: 'breast',
    fractionDose: 3.01,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-22',
    tumourStream: 'skin',
    fractionDose: 3.29,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-30',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-21',
    tumourStream: 'gi',
    fractionDose: 2.43,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-31',
    tumourStream: 'breast',
    fractionDose: 3.08,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-21',
    tumourStream: 'brain',
    fractionDose: 2.18,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-06',
    tumourStream: 'Unspecified',
    fractionDose: 3.35,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-18',
    tumourStream: 'urogenital',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-03',
    tumourStream: 'metastasis',
    fractionDose: 1.61,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-21',
    tumourStream: 'brain',
    fractionDose: 1.65,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-13',
    tumourStream: 'gi',
    fractionDose: 1.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-19',
    tumourStream: 'Unspecified',
    fractionDose: 3.07,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-27',
    tumourStream: 'brain',
    fractionDose: 3.09,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-18',
    tumourStream: 'breast',
    fractionDose: 2.99,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-28',
    tumourStream: 'breast',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-10',
    tumourStream: 'metastasis',
    fractionDose: 2.69,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-18',
    tumourStream: 'metastasis',
    fractionDose: 3.25,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-19',
    tumourStream: 'metastasis',
    fractionDose: 3.19,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-17',
    tumourStream: 'metastasis',
    fractionDose: 1.65,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-01',
    tumourStream: 'gi',
    fractionDose: 1.32,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-12',
    tumourStream: 'breast',
    fractionDose: 2.43,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-23',
    tumourStream: 'metastasis',
    fractionDose: 3.25,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-02',
    tumourStream: 'metastasis',
    fractionDose: 2.61,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-28',
    tumourStream: 'urogenital',
    fractionDose: 2.99,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-09',
    tumourStream: 'breast',
    fractionDose: 1.29,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-13',
    tumourStream: 'urogenital',
    fractionDose: 2.81,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-29',
    tumourStream: 'metastasis',
    fractionDose: 1.65,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-28',
    tumourStream: 'urogenital',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-06',
    tumourStream: 'gi',
    fractionDose: 1.41,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-13',
    tumourStream: 'gi',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-22',
    tumourStream: 'Unspecified',
    fractionDose: 2.78,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-27',
    tumourStream: 'Unspecified',
    fractionDose: 3.29,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-29',
    tumourStream: 'brain',
    fractionDose: 1.63,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-08',
    tumourStream: 'Unspecified',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-14',
    tumourStream: 'skin',
    fractionDose: 2.89,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-17',
    tumourStream: 'skin',
    fractionDose: 1.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-16',
    tumourStream: 'skin',
    fractionDose: 2.72,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-11',
    tumourStream: 'urogenital',
    fractionDose: 1.26,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-09',
    tumourStream: 'Unspecified',
    fractionDose: 3.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-11',
    tumourStream: 'metastasis',
    fractionDose: 1.65,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-14',
    tumourStream: 'brain',
    fractionDose: 2.06,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-04',
    tumourStream: 'metastasis',
    fractionDose: 1.92,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-29',
    tumourStream: 'urogenital',
    fractionDose: 2.86,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-22',
    tumourStream: 'Unspecified',
    fractionDose: 1.7,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-18',
    tumourStream: 'urogenital',
    fractionDose: 2.72,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-28',
    tumourStream: 'metastasis',
    fractionDose: 3.06,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-07',
    tumourStream: 'skin',
    fractionDose: 1.27,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-14',
    tumourStream: 'metastasis',
    fractionDose: 3.03,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-30',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-28',
    tumourStream: 'metastasis',
    fractionDose: 2.37,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-14',
    tumourStream: 'brain',
    fractionDose: 2.42,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-05',
    tumourStream: 'brain',
    fractionDose: 2.13,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-23',
    tumourStream: 'gi',
    fractionDose: 1.59,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-26',
    tumourStream: 'skin',
    fractionDose: 2.69,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-18',
    tumourStream: 'metastasis',
    fractionDose: 1.39,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-27',
    tumourStream: 'gi',
    fractionDose: 2.31,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-20',
    tumourStream: 'breast',
    fractionDose: 2.26,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-21',
    tumourStream: 'gi',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-07',
    tumourStream: 'urogenital',
    fractionDose: 2.04,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-11',
    tumourStream: 'urogenital',
    fractionDose: 2.62,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-16',
    tumourStream: 'brain',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-23',
    tumourStream: 'Unspecified',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-04',
    tumourStream: 'metastasis',
    fractionDose: 2.09,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-02',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-04',
    tumourStream: 'urogenital',
    fractionDose: 1.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-28',
    tumourStream: 'gi',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-19',
    tumourStream: 'Unspecified',
    fractionDose: 1.73,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-21',
    tumourStream: 'brain',
    fractionDose: 1.42,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-12',
    tumourStream: 'urogenital',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-05',
    tumourStream: 'urogenital',
    fractionDose: 2.77,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-22',
    tumourStream: 'gi',
    fractionDose: 3.19,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-26',
    tumourStream: 'metastasis',
    fractionDose: 3.36,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-07',
    tumourStream: 'Unspecified',
    fractionDose: 2.01,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-27',
    tumourStream: 'brain',
    fractionDose: 3.38,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-18',
    tumourStream: 'skin',
    fractionDose: 2.72,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-29',
    tumourStream: 'gi',
    fractionDose: 2.07,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-03',
    tumourStream: 'Unspecified',
    fractionDose: 1.35,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-15',
    tumourStream: 'breast',
    fractionDose: 2.01,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-19',
    tumourStream: 'skin',
    fractionDose: 1.91,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-13',
    tumourStream: 'gi',
    fractionDose: 1.88,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-09',
    tumourStream: 'urogenital',
    fractionDose: 2.92,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-22',
    tumourStream: 'metastasis',
    fractionDose: 1.82,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-06',
    tumourStream: 'gi',
    fractionDose: 2.57,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-02',
    tumourStream: 'breast',
    fractionDose: 3.01,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-23',
    tumourStream: 'brain',
    fractionDose: 2.95,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-21',
    tumourStream: 'urogenital',
    fractionDose: 2.19,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-12',
    tumourStream: 'skin',
    fractionDose: 3.19,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-19',
    tumourStream: 'gi',
    fractionDose: 1.21,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-17',
    tumourStream: 'urogenital',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-23',
    tumourStream: 'metastasis',
    fractionDose: 1.91,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-28',
    tumourStream: 'skin',
    fractionDose: 2.47,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-24',
    tumourStream: 'metastasis',
    fractionDose: 2.73,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-08',
    tumourStream: 'metastasis',
    fractionDose: 1.35,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-08',
    tumourStream: 'urogenital',
    fractionDose: 2.22,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-16',
    tumourStream: 'metastasis',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-19',
    tumourStream: 'gi',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-09',
    tumourStream: 'breast',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-22',
    tumourStream: 'gi',
    fractionDose: 1.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-05',
    tumourStream: 'breast',
    fractionDose: 1.91,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-04',
    tumourStream: 'gi',
    fractionDose: 3.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-30',
    tumourStream: 'brain',
    fractionDose: 1.42,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-21',
    tumourStream: 'urogenital',
    fractionDose: 2.23,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-11',
    tumourStream: 'breast',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-24',
    tumourStream: 'urogenital',
    fractionDose: 1.54,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-08',
    tumourStream: 'skin',
    fractionDose: 3.19,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-12',
    tumourStream: 'urogenital',
    fractionDose: 1.31,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-26',
    tumourStream: 'brain',
    fractionDose: 1.85,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-06',
    tumourStream: 'Unspecified',
    fractionDose: 3.32,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-23',
    tumourStream: 'breast',
    fractionDose: 1.98,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-14',
    tumourStream: 'urogenital',
    fractionDose: 1.26,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-18',
    tumourStream: 'gi',
    fractionDose: 1.66,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-24',
    tumourStream: 'breast',
    fractionDose: 2.51,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-30',
    tumourStream: 'metastasis',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-02',
    tumourStream: 'Unspecified',
    fractionDose: 2.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-27',
    tumourStream: 'Unspecified',
    fractionDose: 1.86,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-28',
    tumourStream: 'breast',
    fractionDose: 2.54,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-05',
    tumourStream: 'metastasis',
    fractionDose: 2.79,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-20',
    tumourStream: 'gi',
    fractionDose: 2.22,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-13',
    tumourStream: 'gi',
    fractionDose: 1.33,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-07',
    tumourStream: 'brain',
    fractionDose: 1.87,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-22',
    tumourStream: 'urogenital',
    fractionDose: 1.71,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-23',
    tumourStream: 'urogenital',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-21',
    tumourStream: 'gi',
    fractionDose: 1.3,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-29',
    tumourStream: 'skin',
    fractionDose: 2.81,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-16',
    tumourStream: 'breast',
    fractionDose: 1.6,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-22',
    tumourStream: 'gi',
    fractionDose: 3.24,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-21',
    tumourStream: 'metastasis',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-01',
    tumourStream: 'breast',
    fractionDose: 3.07,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-25',
    tumourStream: 'urogenital',
    fractionDose: 2.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-12',
    tumourStream: 'breast',
    fractionDose: 2.04,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-02',
    tumourStream: 'breast',
    fractionDose: 1.38,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-06',
    tumourStream: 'brain',
    fractionDose: 2.21,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-29',
    tumourStream: 'breast',
    fractionDose: 2.22,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-12',
    tumourStream: 'urogenital',
    fractionDose: 2.54,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-23',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-25',
    tumourStream: 'breast',
    fractionDose: 2.76,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-20',
    tumourStream: 'skin',
    fractionDose: 2.77,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-25',
    tumourStream: 'breast',
    fractionDose: 2.17,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-13',
    tumourStream: 'skin',
    fractionDose: 2.48,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-27',
    tumourStream: 'Unspecified',
    fractionDose: 2.67,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-06',
    tumourStream: 'breast',
    fractionDose: 3.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-16',
    tumourStream: 'breast',
    fractionDose: 2.28,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-23',
    tumourStream: 'Unspecified',
    fractionDose: 2.19,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-21',
    tumourStream: 'breast',
    fractionDose: 1.86,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-23',
    tumourStream: 'breast',
    fractionDose: 2.87,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-18',
    tumourStream: 'brain',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-14',
    tumourStream: 'Unspecified',
    fractionDose: 1.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-26',
    tumourStream: 'brain',
    fractionDose: 1.67,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-11',
    tumourStream: 'urogenital',
    fractionDose: 2.96,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-26',
    tumourStream: 'brain',
    fractionDose: 1.97,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-29',
    tumourStream: 'skin',
    fractionDose: 1.89,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-04',
    tumourStream: 'urogenital',
    fractionDose: 1.88,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-03',
    tumourStream: 'urogenital',
    fractionDose: 3.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-17',
    tumourStream: 'gi',
    fractionDose: 3.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-22',
    tumourStream: 'breast',
    fractionDose: 2.46,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-07',
    tumourStream: 'skin',
    fractionDose: 2.55,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-17',
    tumourStream: 'metastasis',
    fractionDose: 2.37,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-02',
    tumourStream: 'brain',
    fractionDose: 1.84,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-25',
    tumourStream: 'Unspecified',
    fractionDose: 2.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-03',
    tumourStream: 'brain',
    fractionDose: 1.75,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-29',
    tumourStream: 'urogenital',
    fractionDose: 2.03,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-10',
    tumourStream: 'Unspecified',
    fractionDose: 2.04,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-06',
    tumourStream: 'gi',
    fractionDose: 2.17,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-19',
    tumourStream: 'breast',
    fractionDose: 1.72,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-07',
    tumourStream: 'brain',
    fractionDose: 2.54,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-05',
    tumourStream: 'Unspecified',
    fractionDose: 1.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-14',
    tumourStream: 'skin',
    fractionDose: 1.43,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-18',
    tumourStream: 'gi',
    fractionDose: 1.58,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-16',
    tumourStream: 'skin',
    fractionDose: 3.13,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-14',
    tumourStream: 'gi',
    fractionDose: 1.96,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-11',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-14',
    tumourStream: 'breast',
    fractionDose: 1.24,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-20',
    tumourStream: 'breast',
    fractionDose: 1.65,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-04',
    tumourStream: 'breast',
    fractionDose: 1.93,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-25',
    tumourStream: 'metastasis',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-29',
    tumourStream: 'metastasis',
    fractionDose: 2.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-25',
    tumourStream: 'metastasis',
    fractionDose: 2.51,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-26',
    tumourStream: 'brain',
    fractionDose: 1.77,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-10',
    tumourStream: 'breast',
    fractionDose: 2.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-10',
    tumourStream: 'gi',
    fractionDose: 2.63,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-18',
    tumourStream: 'breast',
    fractionDose: 1.49,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-25',
    tumourStream: 'gi',
    fractionDose: 2.05,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-03',
    tumourStream: 'metastasis',
    fractionDose: 2.91,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-05',
    tumourStream: 'brain',
    fractionDose: 2.82,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-29',
    tumourStream: 'metastasis',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-05',
    tumourStream: 'metastasis',
    fractionDose: 1.79,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-23',
    tumourStream: 'metastasis',
    fractionDose: 2.58,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-09',
    tumourStream: 'breast',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-10',
    tumourStream: 'metastasis',
    fractionDose: 3.01,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-23',
    tumourStream: 'urogenital',
    fractionDose: 2.39,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-10',
    tumourStream: 'Unspecified',
    fractionDose: 2.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-30',
    tumourStream: 'breast',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-19',
    tumourStream: 'breast',
    fractionDose: 1.72,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-09',
    tumourStream: 'skin',
    fractionDose: 1.91,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-23',
    tumourStream: 'brain',
    fractionDose: 2.36,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-01',
    tumourStream: 'brain',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-20',
    tumourStream: 'brain',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-07',
    tumourStream: 'skin',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-08',
    tumourStream: 'brain',
    fractionDose: 1.43,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-21',
    tumourStream: 'breast',
    fractionDose: 1.51,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-16',
    tumourStream: 'breast',
    fractionDose: 2.03,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-26',
    tumourStream: 'skin',
    fractionDose: 2.41,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-01',
    tumourStream: 'brain',
    fractionDose: 2.04,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-07',
    tumourStream: 'Unspecified',
    fractionDose: 3.06,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-18',
    tumourStream: 'gi',
    fractionDose: 1.43,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-24',
    tumourStream: 'skin',
    fractionDose: 1.55,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-04',
    tumourStream: 'gi',
    fractionDose: 3.14,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-20',
    tumourStream: 'metastasis',
    fractionDose: 3.22,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-07',
    tumourStream: 'urogenital',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-11',
    tumourStream: 'Unspecified',
    fractionDose: 1.88,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-06',
    tumourStream: 'gi',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-30',
    tumourStream: 'breast',
    fractionDose: 2.34,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-04',
    tumourStream: 'metastasis',
    fractionDose: 3.26,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-28',
    tumourStream: 'breast',
    fractionDose: 1.45,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-14',
    tumourStream: 'urogenital',
    fractionDose: 2.24,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-13',
    tumourStream: 'breast',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-21',
    tumourStream: 'brain',
    fractionDose: 3.15,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-14',
    tumourStream: 'brain',
    fractionDose: 3.18,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-28',
    tumourStream: 'brain',
    fractionDose: 2.87,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-21',
    tumourStream: 'metastasis',
    fractionDose: 1.26,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-19',
    tumourStream: 'skin',
    fractionDose: 1.25,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-22',
    tumourStream: 'Unspecified',
    fractionDose: 3.32,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-15',
    tumourStream: 'Unspecified',
    fractionDose: 1.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-25',
    tumourStream: 'gi',
    fractionDose: 2.61,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-08',
    tumourStream: 'urogenital',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-17',
    tumourStream: 'urogenital',
    fractionDose: 2.15,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-25',
    tumourStream: 'skin',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-07',
    tumourStream: 'gi',
    fractionDose: 2.15,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-06',
    tumourStream: 'Unspecified',
    fractionDose: 2.66,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-17',
    tumourStream: 'metastasis',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-27',
    tumourStream: 'Unspecified',
    fractionDose: 2.75,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-29',
    tumourStream: 'urogenital',
    fractionDose: 2.72,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-30',
    tumourStream: 'skin',
    fractionDose: 2.12,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-14',
    tumourStream: 'breast',
    fractionDose: 1.57,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-14',
    tumourStream: 'Unspecified',
    fractionDose: 1.53,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-14',
    tumourStream: 'gi',
    fractionDose: 1.5,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-05',
    tumourStream: 'brain',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-16',
    tumourStream: 'metastasis',
    fractionDose: 1.33,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-01',
    tumourStream: 'metastasis',
    fractionDose: 2.92,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-16',
    tumourStream: 'gi',
    fractionDose: 2.61,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-05',
    tumourStream: 'urogenital',
    fractionDose: 1.35,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-12',
    tumourStream: 'skin',
    fractionDose: 2.18,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-22',
    tumourStream: 'breast',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-07',
    tumourStream: 'urogenital',
    fractionDose: 2.38,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-17',
    tumourStream: 'gi',
    fractionDose: 2.57,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-23',
    tumourStream: 'Unspecified',
    fractionDose: 2.24,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-07',
    tumourStream: 'brain',
    fractionDose: 1.73,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-09',
    tumourStream: 'metastasis',
    fractionDose: 2.58,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-06',
    tumourStream: 'Unspecified',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-23',
    tumourStream: 'urogenital',
    fractionDose: 1.24,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-02',
    tumourStream: 'brain',
    fractionDose: 1.96,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-06',
    tumourStream: 'Unspecified',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-24',
    tumourStream: 'skin',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-05',
    tumourStream: 'breast',
    fractionDose: 2.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-18',
    tumourStream: 'metastasis',
    fractionDose: 3.27,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-18',
    tumourStream: 'Unspecified',
    fractionDose: 3.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-02',
    tumourStream: 'urogenital',
    fractionDose: 1.45,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-13',
    tumourStream: 'urogenital',
    fractionDose: 2.55,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-19',
    tumourStream: 'Unspecified',
    fractionDose: 1.89,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-19',
    tumourStream: 'breast',
    fractionDose: 2.86,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-16',
    tumourStream: 'urogenital',
    fractionDose: 3.05,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-20',
    tumourStream: 'gi',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-04',
    tumourStream: 'gi',
    fractionDose: 2.67,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-27',
    tumourStream: 'gi',
    fractionDose: 1.53,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-28',
    tumourStream: 'metastasis',
    fractionDose: 2.63,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-10',
    tumourStream: 'urogenital',
    fractionDose: 2.08,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-18',
    tumourStream: 'Unspecified',
    fractionDose: 2.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-10',
    tumourStream: 'gi',
    fractionDose: 2.46,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-27',
    tumourStream: 'urogenital',
    fractionDose: 1.49,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-30',
    tumourStream: 'Unspecified',
    fractionDose: 1.66,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-18',
    tumourStream: 'breast',
    fractionDose: 2.73,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-08',
    tumourStream: 'breast',
    fractionDose: 1.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-12',
    tumourStream: 'brain',
    fractionDose: 1.44,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-14',
    tumourStream: 'breast',
    fractionDose: 1.73,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-19',
    tumourStream: 'Unspecified',
    fractionDose: 2.72,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-09',
    tumourStream: 'metastasis',
    fractionDose: 3.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-06',
    tumourStream: 'gi',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-19',
    tumourStream: 'brain',
    fractionDose: 1.86,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-15',
    tumourStream: 'brain',
    fractionDose: 1.21,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-20',
    tumourStream: 'urogenital',
    fractionDose: 2.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-29',
    tumourStream: 'Unspecified',
    fractionDose: 1.83,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-09',
    tumourStream: 'metastasis',
    fractionDose: 1.9,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-12',
    tumourStream: 'skin',
    fractionDose: 1.31,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-07',
    tumourStream: 'brain',
    fractionDose: 2.56,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-12',
    tumourStream: 'urogenital',
    fractionDose: 2.97,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-15',
    tumourStream: 'brain',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-07',
    tumourStream: 'metastasis',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-28',
    tumourStream: 'metastasis',
    fractionDose: 2.03,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-26',
    tumourStream: 'gi',
    fractionDose: 2.19,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-08',
    tumourStream: 'metastasis',
    fractionDose: 2.38,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-26',
    tumourStream: 'breast',
    fractionDose: 2.24,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-16',
    tumourStream: 'Unspecified',
    fractionDose: 1.94,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-16',
    tumourStream: 'skin',
    fractionDose: 2.58,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-29',
    tumourStream: 'metastasis',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-02',
    tumourStream: 'breast',
    fractionDose: 1.32,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-17',
    tumourStream: 'skin',
    fractionDose: 2.47,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-21',
    tumourStream: 'urogenital',
    fractionDose: 1.79,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-09',
    tumourStream: 'skin',
    fractionDose: 1.78,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-28',
    tumourStream: 'gi',
    fractionDose: 3.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-02',
    tumourStream: 'brain',
    fractionDose: 3.14,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-20',
    tumourStream: 'Unspecified',
    fractionDose: 1.27,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-20',
    tumourStream: 'Unspecified',
    fractionDose: 2.44,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-03',
    tumourStream: 'urogenital',
    fractionDose: 2.25,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-24',
    tumourStream: 'breast',
    fractionDose: 2.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-13',
    tumourStream: 'metastasis',
    fractionDose: 3.03,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-23',
    tumourStream: 'breast',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-30',
    tumourStream: 'skin',
    fractionDose: 3.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-17',
    tumourStream: 'skin',
    fractionDose: 1.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-21',
    tumourStream: 'metastasis',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-10',
    tumourStream: 'metastasis',
    fractionDose: 3.36,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-29',
    tumourStream: 'metastasis',
    fractionDose: 2.1,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.63,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-13',
    tumourStream: 'metastasis',
    fractionDose: 1.76,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-13',
    tumourStream: 'urogenital',
    fractionDose: 2.46,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-13',
    tumourStream: 'skin',
    fractionDose: 2.84,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-02',
    tumourStream: 'Unspecified',
    fractionDose: 3.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-03',
    tumourStream: 'brain',
    fractionDose: 1.33,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-28',
    tumourStream: 'brain',
    fractionDose: 2.56,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-16',
    tumourStream: 'breast',
    fractionDose: 2.68,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-15',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-28',
    tumourStream: 'breast',
    fractionDose: 1.84,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-11',
    tumourStream: 'Unspecified',
    fractionDose: 2.77,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-09',
    tumourStream: 'metastasis',
    fractionDose: 2.26,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-14',
    tumourStream: 'metastasis',
    fractionDose: 1.4,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-17',
    tumourStream: 'skin',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-21',
    tumourStream: 'Unspecified',
    fractionDose: 2.01,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-28',
    tumourStream: 'brain',
    fractionDose: 1.78,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-05',
    tumourStream: 'Unspecified',
    fractionDose: 2.65,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-15',
    tumourStream: 'urogenital',
    fractionDose: 1.93,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-08',
    tumourStream: 'metastasis',
    fractionDose: 3.12,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-25',
    tumourStream: 'Unspecified',
    fractionDose: 1.72,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-18',
    tumourStream: 'Unspecified',
    fractionDose: 2.07,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-19',
    tumourStream: 'urogenital',
    fractionDose: 2.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-23',
    tumourStream: 'metastasis',
    fractionDose: 3.32,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-01',
    tumourStream: 'urogenital',
    fractionDose: 3.29,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-01',
    tumourStream: 'brain',
    fractionDose: 1.69,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-01',
    tumourStream: 'skin',
    fractionDose: 3.05,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-22',
    tumourStream: 'urogenital',
    fractionDose: 1.67,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-15',
    tumourStream: 'brain',
    fractionDose: 1.34,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-02',
    tumourStream: 'urogenital',
    fractionDose: 2.9,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-09',
    tumourStream: 'Unspecified',
    fractionDose: 2.54,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-25',
    tumourStream: 'brain',
    fractionDose: 1.51,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-26',
    tumourStream: 'metastasis',
    fractionDose: 1.79,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-16',
    tumourStream: 'urogenital',
    fractionDose: 2.6,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-30',
    tumourStream: 'brain',
    fractionDose: 2.61,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-04',
    tumourStream: 'metastasis',
    fractionDose: 1.32,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-05',
    tumourStream: 'gi',
    fractionDose: 1.47,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-22',
    tumourStream: 'breast',
    fractionDose: 1.23,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-26',
    tumourStream: 'metastasis',
    fractionDose: 3.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-07',
    tumourStream: 'Unspecified',
    fractionDose: 1.37,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-21',
    tumourStream: 'breast',
    fractionDose: 1.85,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-08',
    tumourStream: 'skin',
    fractionDose: 2.11,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-22',
    tumourStream: 'brain',
    fractionDose: 2.78,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-31',
    tumourStream: 'urogenital',
    fractionDose: 1.49,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-22',
    tumourStream: 'gi',
    fractionDose: 1.8,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-02',
    tumourStream: 'skin',
    fractionDose: 2.64,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-02',
    tumourStream: 'skin',
    fractionDose: 3.34,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-02',
    tumourStream: 'skin',
    fractionDose: 1.5,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-28',
    tumourStream: 'brain',
    fractionDose: 2.51,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-06',
    tumourStream: 'metastasis',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-24',
    tumourStream: 'brain',
    fractionDose: 1.65,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'Unspecified',
    fractionDose: 2.66,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-09',
    tumourStream: 'Unspecified',
    fractionDose: 2.57,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-28',
    tumourStream: 'brain',
    fractionDose: 2.01,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-17',
    tumourStream: 'Unspecified',
    fractionDose: 1.49,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-18',
    tumourStream: 'gi',
    fractionDose: 3.31,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-12',
    tumourStream: 'Unspecified',
    fractionDose: 2.13,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-06',
    tumourStream: 'metastasis',
    fractionDose: 1.23,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-04',
    tumourStream: 'metastasis',
    fractionDose: 1.89,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-11',
    tumourStream: 'brain',
    fractionDose: 1.78,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-18',
    tumourStream: 'breast',
    fractionDose: 1.49,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-15',
    tumourStream: 'urogenital',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-18',
    tumourStream: 'urogenital',
    fractionDose: 3.14,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-04',
    tumourStream: 'brain',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-18',
    tumourStream: 'skin',
    fractionDose: 1.33,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-15',
    tumourStream: 'skin',
    fractionDose: 2.55,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-25',
    tumourStream: 'breast',
    fractionDose: 2.77,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-08',
    tumourStream: 'metastasis',
    fractionDose: 3.05,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-26',
    tumourStream: 'gi',
    fractionDose: 2.44,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-31',
    tumourStream: 'Unspecified',
    fractionDose: 2.98,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-21',
    tumourStream: 'skin',
    fractionDose: 1.75,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-25',
    tumourStream: 'breast',
    fractionDose: 3.21,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-17',
    tumourStream: 'Unspecified',
    fractionDose: 2.13,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-18',
    tumourStream: 'urogenital',
    fractionDose: 1.23,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-05',
    tumourStream: 'brain',
    fractionDose: 3.21,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-14',
    tumourStream: 'skin',
    fractionDose: 2.14,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-31',
    tumourStream: 'brain',
    fractionDose: 3.36,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-27',
    tumourStream: 'Unspecified',
    fractionDose: 2.61,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-03',
    tumourStream: 'Unspecified',
    fractionDose: 1.47,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-08',
    tumourStream: 'gi',
    fractionDose: 3.39,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-29',
    tumourStream: 'urogenital',
    fractionDose: 1.74,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-15',
    tumourStream: 'gi',
    fractionDose: 2.49,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-23',
    tumourStream: 'breast',
    fractionDose: 2.55,
    adherence: false,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-20',
    tumourStream: 'urogenital',
    fractionDose: 2.23,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-12',
    tumourStream: 'metastasis',
    fractionDose: 2.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-05',
    tumourStream: 'brain',
    fractionDose: 3.07,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-04',
    tumourStream: 'brain',
    fractionDose: 2.73,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-09',
    tumourStream: 'gi',
    fractionDose: 3.32,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-28',
    tumourStream: 'metastasis',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-21',
    tumourStream: 'breast',
    fractionDose: 1.98,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-21',
    tumourStream: 'Unspecified',
    fractionDose: 1.96,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-23',
    tumourStream: 'gi',
    fractionDose: 3.17,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-06',
    tumourStream: 'brain',
    fractionDose: 2.69,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-22',
    tumourStream: 'Unspecified',
    fractionDose: 2.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-29',
    tumourStream: 'skin',
    fractionDose: 3.29,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-29',
    tumourStream: 'breast',
    fractionDose: 1.67,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-02',
    tumourStream: 'gi',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-06',
    tumourStream: 'skin',
    fractionDose: 1.28,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-30',
    tumourStream: 'metastasis',
    fractionDose: 2.06,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-10',
    tumourStream: 'Unspecified',
    fractionDose: 2.99,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-01',
    tumourStream: 'gi',
    fractionDose: 2.52,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-05',
    tumourStream: 'urogenital',
    fractionDose: 2.42,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-30',
    tumourStream: 'skin',
    fractionDose: 2.72,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-25',
    tumourStream: 'breast',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-12',
    tumourStream: 'brain',
    fractionDose: 2.84,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-21',
    tumourStream: 'Unspecified',
    fractionDose: 3.01,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-11',
    tumourStream: 'brain',
    fractionDose: 2.1,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-21',
    tumourStream: 'metastasis',
    fractionDose: 2.78,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-01',
    tumourStream: 'breast',
    fractionDose: 3.13,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-11',
    tumourStream: 'skin',
    fractionDose: 2.04,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-04',
    tumourStream: 'urogenital',
    fractionDose: 2.02,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-01',
    tumourStream: 'urogenital',
    fractionDose: 2.63,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-12',
    tumourStream: 'brain',
    fractionDose: 3.06,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-23',
    tumourStream: 'breast',
    fractionDose: 2.32,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-02-04',
    tumourStream: 'gi',
    fractionDose: 2.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-10',
    tumourStream: 'gi',
    fractionDose: 2.28,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-18',
    tumourStream: 'brain',
    fractionDose: 2.53,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-22',
    tumourStream: 'urogenital',
    fractionDose: 2.01,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-30',
    tumourStream: 'urogenital',
    fractionDose: 3.13,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-09',
    tumourStream: 'breast',
    fractionDose: 1.42,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-16',
    tumourStream: 'urogenital',
    fractionDose: 1.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-31',
    tumourStream: 'breast',
    fractionDose: 1.75,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-27',
    tumourStream: 'breast',
    fractionDose: 1.46,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-21',
    tumourStream: 'skin',
    fractionDose: 2.41,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-02',
    tumourStream: 'gi',
    fractionDose: 1.69,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-14',
    tumourStream: 'urogenital',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-20',
    tumourStream: 'brain',
    fractionDose: 2.18,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-20',
    tumourStream: 'skin',
    fractionDose: 1.98,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-19',
    tumourStream: 'gi',
    fractionDose: 2.21,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-20',
    tumourStream: 'Unspecified',
    fractionDose: 1.71,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-21',
    tumourStream: 'skin',
    fractionDose: 2.12,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-19',
    tumourStream: 'breast',
    fractionDose: 2.07,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-01',
    tumourStream: 'gi',
    fractionDose: 3.16,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-09',
    tumourStream: 'urogenital',
    fractionDose: 3.34,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-04',
    tumourStream: 'urogenital',
    fractionDose: 2.74,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-02',
    tumourStream: 'brain',
    fractionDose: 3.33,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-01',
    tumourStream: 'urogenital',
    fractionDose: 2.41,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-22',
    tumourStream: 'urogenital',
    fractionDose: 1.75,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-14',
    tumourStream: 'brain',
    fractionDose: 2.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-20',
    tumourStream: 'breast',
    fractionDose: 1.91,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-01',
    tumourStream: 'skin',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-06',
    tumourStream: 'skin',
    fractionDose: 2.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-09',
    tumourStream: 'breast',
    fractionDose: 3.38,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-27',
    tumourStream: 'gi',
    fractionDose: 1.58,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-23',
    tumourStream: 'gi',
    fractionDose: 1.83,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-18',
    tumourStream: 'brain',
    fractionDose: 1.27,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-14',
    tumourStream: 'skin',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-23',
    tumourStream: 'urogenital',
    fractionDose: 2.23,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-25',
    tumourStream: 'gi',
    fractionDose: 2.49,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-07',
    tumourStream: 'brain',
    fractionDose: 1.21,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-11',
    tumourStream: 'urogenital',
    fractionDose: 1.79,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-12',
    tumourStream: 'metastasis',
    fractionDose: 1.31,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 10,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-31',
    tumourStream: 'brain',
    fractionDose: 1.73,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-04-09',
    tumourStream: 'breast',
    fractionDose: 3.03,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-15',
    tumourStream: 'urogenital',
    fractionDose: 1.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-22',
    tumourStream: 'brain',
    fractionDose: 2.49,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-19',
    tumourStream: 'Unspecified',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-02',
    tumourStream: 'urogenital',
    fractionDose: 2.05,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-08',
    tumourStream: 'metastasis',
    fractionDose: 3.24,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-28',
    tumourStream: 'skin',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-25',
    tumourStream: 'skin',
    fractionDose: 2.21,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-30',
    tumourStream: 'brain',
    fractionDose: 1.76,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-13',
    tumourStream: 'Unspecified',
    fractionDose: 3.33,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-16',
    tumourStream: 'metastasis',
    fractionDose: 2.28,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-09',
    tumourStream: 'gi',
    fractionDose: 2.5,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-23',
    tumourStream: 'metastasis',
    fractionDose: 2.19,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-02-09',
    tumourStream: 'gi',
    fractionDose: 2.36,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-07-23',
    tumourStream: 'Unspecified',
    fractionDose: 2.24,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-26',
    tumourStream: 'urogenital',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-11',
    tumourStream: 'metastasis',
    fractionDose: 2.59,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 22,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-09',
    tumourStream: 'skin',
    fractionDose: 1.79,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-06-06',
    tumourStream: 'skin',
    fractionDose: 3.0,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-12',
    tumourStream: 'brain',
    fractionDose: 2.17,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-30',
    tumourStream: 'gi',
    fractionDose: 2.63,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-05',
    tumourStream: 'brain',
    fractionDose: 1.24,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-25',
    tumourStream: 'breast',
    fractionDose: 3.32,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-11',
    tumourStream: 'Unspecified',
    fractionDose: 1.44,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-26',
    tumourStream: 'urogenital',
    fractionDose: 3.11,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-24',
    tumourStream: 'brain',
    fractionDose: 2.07,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-04',
    tumourStream: 'gi',
    fractionDose: 2.0,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-06-22',
    tumourStream: 'breast',
    fractionDose: 2.2,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-03',
    tumourStream: 'Unspecified',
    fractionDose: 3.13,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-11',
    tumourStream: 'gi',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-05',
    tumourStream: 'breast',
    fractionDose: 1.7,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-17',
    tumourStream: 'brain',
    fractionDose: 1.47,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 10,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-19',
    tumourStream: 'skin',
    fractionDose: 1.41,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-05',
    tumourStream: 'gi',
    fractionDose: 2.18,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-13',
    tumourStream: 'skin',
    fractionDose: 2.7,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-29',
    tumourStream: 'gi',
    fractionDose: 2.97,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C20',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-15',
    tumourStream: 'Unspecified',
    fractionDose: 2.02,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-07-31',
    tumourStream: 'Unspecified',
    fractionDose: 2.49,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-07',
    tumourStream: 'urogenital',
    fractionDose: 3.03,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-16',
    tumourStream: 'breast',
    fractionDose: 2.79,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-03-16',
    tumourStream: 'skin',
    fractionDose: 2.3,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-03',
    tumourStream: 'urogenital',
    fractionDose: 1.71,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-30',
    tumourStream: 'gi',
    fractionDose: 3.14,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-15',
    tumourStream: 'brain',
    fractionDose: 2.04,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C61',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-08',
    tumourStream: 'Unspecified',
    fractionDose: 3.35,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-11-14',
    tumourStream: 'metastasis',
    fractionDose: 2.07,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-31',
    tumourStream: 'skin',
    fractionDose: 1.94,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-03-04',
    tumourStream: 'gi',
    fractionDose: 2.63,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-18',
    tumourStream: 'skin',
    fractionDose: 2.88,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-19',
    tumourStream: 'Unspecified',
    fractionDose: 3.37,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-31',
    tumourStream: 'metastasis',
    fractionDose: 2.38,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-12',
    tumourStream: 'Unspecified',
    fractionDose: 2.29,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-06',
    tumourStream: 'metastasis',
    fractionDose: 2.81,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-28',
    tumourStream: 'urogenital',
    fractionDose: 3.27,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-26',
    tumourStream: 'brain',
    fractionDose: 1.73,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-05',
    tumourStream: 'metastasis',
    fractionDose: 1.22,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-08',
    tumourStream: 'urogenital',
    fractionDose: 1.61,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-03',
    tumourStream: 'breast',
    fractionDose: 2.39,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C20',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-14',
    tumourStream: 'gi',
    fractionDose: 3.17,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-13',
    tumourStream: 'breast',
    fractionDose: 1.71,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-24',
    tumourStream: 'skin',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-01',
    tumourStream: 'brain',
    fractionDose: 1.47,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-24',
    tumourStream: 'brain',
    fractionDose: 2.94,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-09',
    tumourStream: 'breast',
    fractionDose: 3.23,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-01',
    tumourStream: 'Unspecified',
    fractionDose: 2.62,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-18',
    tumourStream: 'breast',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-09',
    tumourStream: 'metastasis',
    fractionDose: 2.58,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-16',
    tumourStream: 'skin',
    fractionDose: 2.61,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-23',
    tumourStream: 'metastasis',
    fractionDose: 3.15,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C61',
  },
  {
    fractions: 15,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-03',
    tumourStream: 'skin',
    fractionDose: 3.03,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-06',
    tumourStream: 'metastasis',
    fractionDose: 1.22,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C61',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-20',
    tumourStream: 'breast',
    fractionDose: 3.13,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-03',
    tumourStream: 'gi',
    fractionDose: 1.36,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-14',
    tumourStream: 'breast',
    fractionDose: 3.07,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-22',
    tumourStream: 'skin',
    fractionDose: 2.11,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-25',
    tumourStream: 'metastasis',
    fractionDose: 2.34,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C61',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-09-18',
    tumourStream: 'brain',
    fractionDose: 2.79,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-15',
    tumourStream: 'breast',
    fractionDose: 1.75,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-19',
    tumourStream: 'metastasis',
    fractionDose: 1.87,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2024-10-21',
    tumourStream: 'gi',
    fractionDose: 1.99,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-21',
    tumourStream: 'Unspecified',
    fractionDose: 2.43,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-23',
    tumourStream: 'breast',
    fractionDose: 2.65,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-25',
    tumourStream: 'skin',
    fractionDose: 2.89,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-08-19',
    tumourStream: 'skin',
    fractionDose: 1.25,
    adherence: false,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-25',
    tumourStream: 'Unspecified',
    fractionDose: 1.84,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-01',
    tumourStream: 'gi',
    fractionDose: 2.71,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-22',
    tumourStream: 'Unspecified',
    fractionDose: 3.18,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 23,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-03',
    tumourStream: 'Unspecified',
    fractionDose: 2.76,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-03',
    tumourStream: 'metastasis',
    fractionDose: 2.85,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-06',
    tumourStream: 'breast',
    fractionDose: 2.36,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 20,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-03',
    tumourStream: 'Unspecified',
    fractionDose: 1.74,
    adherence: false,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 21,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2025-04-17',
    tumourStream: 'brain',
    fractionDose: 2.52,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-04-12',
    tumourStream: 'gi',
    fractionDose: 2.29,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-20',
    tumourStream: 'gi',
    fractionDose: 1.47,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Standard',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-05',
    tumourStream: 'breast',
    fractionDose: 3.4,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 14,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-08-24',
    tumourStream: 'brain',
    fractionDose: 2.09,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C20',
  },
  {
    fractions: 22,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-07-21',
    tumourStream: 'metastasis',
    fractionDose: 2.67,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 8,
    priority: 'Emergency',
    referrer: 'Dr. Clara Thompson',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-04-12',
    tumourStream: 'brain',
    fractionDose: 2.16,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 2,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C61',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-06-07',
    tumourStream: 'breast',
    fractionDose: 2.4,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-25',
    tumourStream: 'gi',
    fractionDose: 2.48,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-02',
    tumourStream: 'Unspecified',
    fractionDose: 2.79,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 19,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-02',
    tumourStream: 'urogenital',
    fractionDose: 2.25,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 3,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-09-27',
    tumourStream: 'gi',
    fractionDose: 2.05,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-11',
    tumourStream: 'metastasis',
    fractionDose: 1.5,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 22,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-20',
    tumourStream: 'Unspecified',
    fractionDose: 2.19,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Urgent',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-01-23',
    tumourStream: 'Unspecified',
    fractionDose: 2.33,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-11-29',
    tumourStream: 'metastasis',
    fractionDose: 3.2,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-16',
    tumourStream: 'Unspecified',
    fractionDose: 3.08,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 8,
    priority: 'Standard',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 17,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2024-12-14',
    tumourStream: 'gi',
    fractionDose: 2.58,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 3',
    sim_to_treat: 2,
    priority: 'Emergency',
    referrer: 'Dr. Jonathan Blake',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 19,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-06-16',
    tumourStream: 'breast',
    fractionDose: 2.02,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-12',
    tumourStream: 'urogenital',
    fractionDose: 2.16,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-07-30',
    tumourStream: 'skin',
    fractionDose: 2.12,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 23,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-26',
    tumourStream: 'brain',
    fractionDose: 1.31,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 11,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Smith',
    submittedAt: '2024-10-19',
    tumourStream: 'urogenital',
    fractionDose: 3.39,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 11,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-05',
    tumourStream: 'Unspecified',
    fractionDose: 1.51,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 13,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-09-07',
    tumourStream: 'brain',
    fractionDose: 3.33,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Adams',
    submittedAt: '2025-01-26',
    tumourStream: 'metastasis',
    fractionDose: 1.77,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Standard',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C20',
  },
  {
    fractions: 12,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-02',
    tumourStream: 'brain',
    fractionDose: 2.82,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 20,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-13',
    tumourStream: 'Unspecified',
    fractionDose: 3.23,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-22',
    tumourStream: 'gi',
    fractionDose: 3.19,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Standard',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-12-14',
    tumourStream: 'gi',
    fractionDose: 1.37,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C43.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-08-02',
    tumourStream: 'Unspecified',
    fractionDose: 3.21,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Urgent',
    referrer: 'Dr. Michael Stern',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 24,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-08',
    tumourStream: 'metastasis',
    fractionDose: 1.85,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2024-11-17',
    tumourStream: 'skin',
    fractionDose: 3.26,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-01-08',
    tumourStream: 'breast',
    fractionDose: 2.53,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 3',
    sim_to_treat: 9,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Smith',
    submittedAt: '2025-08-29',
    tumourStream: 'brain',
    fractionDose: 2.43,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 1,
    priority: 'Emergency',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 12,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2024-12-12',
    tumourStream: 'Unspecified',
    fractionDose: 2.13,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 4,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
  {
    fractions: 21,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-01',
    tumourStream: 'skin',
    fractionDose: 2.75,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 2',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Smith',
    submittedAt: '2025-03-19',
    tumourStream: 'breast',
    fractionDose: 2.45,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 1',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 18,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2025-03-11',
    tumourStream: 'urogenital',
    fractionDose: 2.39,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 2',
    sim_to_treat: 2,
    priority: 'Standard',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 10,
    treatingDepartment: 'Red Hills',
    createdBy: 'Dr Adams',
    submittedAt: '2024-10-24',
    tumourStream: 'Unspecified',
    fractionDose: 2.69,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 7,
    priority: 'Emergency',
    referrer: 'Dr. Aisha Patel',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 16,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Wong',
    submittedAt: '2025-02-13',
    tumourStream: 'skin',
    fractionDose: 2.8,
    adherence: true,
    technique: 'Stereotactic',
    linac: 'Machine 2',
    sim_to_treat: 5,
    priority: 'Urgent',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C20',
  },
  {
    fractions: 21,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Adams',
    submittedAt: '2024-12-06',
    tumourStream: 'brain',
    fractionDose: 1.69,
    adherence: true,
    technique: 'IMRT/VMAT',
    linac: 'Machine 1',
    sim_to_treat: 3,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 15,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-01-03',
    tumourStream: 'breast',
    fractionDose: 3.14,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 8,
    priority: 'Urgent',
    referrer: 'Dr. Sophie Greenberg',
    diagnosisCode: 'C71.9',
  },
  {
    fractions: 12,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Adams',
    submittedAt: '2025-05-12',
    tumourStream: 'metastasis',
    fractionDose: 1.74,
    adherence: false,
    technique: 'Stereotactic',
    linac: 'Machine 4',
    sim_to_treat: 1,
    priority: 'Standard',
    referrer: 'Dr. Julian Foster',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 19,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-02-05',
    tumourStream: 'breast',
    fractionDose: 1.91,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 4',
    sim_to_treat: 10,
    priority: 'Emergency',
    referrer: 'Dr. Victor Hernandes',
    diagnosisCode: 'C20',
  },
  {
    fractions: 24,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-10-02',
    tumourStream: 'metastasis',
    fractionDose: 2.05,
    adherence: true,
    technique: 'Brachy',
    linac: 'Machine 1',
    sim_to_treat: 5,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C34.90',
  },
  {
    fractions: 25,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Lopez',
    submittedAt: '2024-11-22',
    tumourStream: 'metastasis',
    fractionDose: 2.41,
    adherence: false,
    technique: 'IMRT/VMAT',
    linac: 'Machine 3',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C61',
  },
  {
    fractions: 25,
    treatingDepartment: 'Campsie',
    createdBy: 'Dr Lopez',
    submittedAt: '2025-05-20',
    tumourStream: 'gi',
    fractionDose: 2.17,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 2',
    sim_to_treat: 4,
    priority: 'Emergency',
    referrer: 'Dr. Rachel Nguyen',
    diagnosisCode: 'C79.81',
  },
  {
    fractions: 14,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Smith',
    submittedAt: '2025-05-03',
    tumourStream: 'skin',
    fractionDose: 1.56,
    adherence: true,
    technique: 'Conformal',
    linac: 'Machine 4',
    sim_to_treat: 6,
    priority: 'Emergency',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C61',
  },
  {
    fractions: 11,
    treatingDepartment: 'Lakeside',
    createdBy: 'Dr Wong',
    submittedAt: '2025-09-27',
    tumourStream: 'Unspecified',
    fractionDose: 1.84,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 7,
    priority: 'Urgent',
    referrer: 'Dr. Alex Reynolds',
    diagnosisCode: 'C20',
  },
  {
    fractions: 10,
    treatingDepartment: 'Rosebush',
    createdBy: 'Dr Wong',
    submittedAt: '2025-05-18',
    tumourStream: 'metastasis',
    fractionDose: 2.98,
    adherence: true,
    technique: 'Unspecified',
    linac: 'Machine 1',
    sim_to_treat: 10,
    priority: 'Standard',
    referrer: 'Dr. Emily Hartman',
    diagnosisCode: 'C61',
  },
];

export default MockData;
